import { render, staticRenderFns } from "./MaidQuickInfo.vue?vue&type=template&id=8b4a23c2&"
import script from "./MaidQuickInfo.vue?vue&type=script&lang=js&"
export * from "./MaidQuickInfo.vue?vue&type=script&lang=js&"
import style0 from "./MaidQuickInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MaidQuickInfo.vue"
export default component.exports